<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_73_1752)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 0C23.1046 0 24 0.895431 24 2L24 22C24 23.1046 23.1046 24 22 24L2 24C0.89543 24 0 23.1046 0 22L0 2C0 0.89543 0.895432 0 2 0L22 0Z" fill="#20C9AC"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.05026 18.364L15.6557 9.75847L15.6557 17.6639L17.6569 17.6568L17.6569 6.34314L6.34315 6.34314V8.33718L14.2415 8.34425L5.63605 16.9497L7.05026 18.364Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_73_1752">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
